import { EventEmitter } from "events";
import dispatcher from "../dispatchers/dispatcher";
import Common from "../constants/common";
import ExtrafieldStore from "./extrafieldstores";
import i18n from ".././i18nNext";
import history from "helper/history";
import React from "react";
import Mapper from "../constants/mapping";
import Api from "../constants/api";
import UserInfoStores from "./userInfoStores";

class ExpenseStores extends EventEmitter {
    constructor() {
        super();
        this.initData();
    }

    initData() {
        this.expensetypes = [];
        this.currencytypes = [];
        this.orgcurrencytypes = {};
        this.orgcurrencytypesMap = {};
        this.category = [];
        this.categoryTree = [];
        this.categoryMap = {};
        this.categoryMCC = [];
        this.errMsg = "";
        this.transactionData = {};
        this.allTxnType = [];
        this.allAutomationMetaDetails = [];
        this.currency_amount = "";
        this.currency = "";
        this.payee_merchant = "";
        this.description = "";
        this.wallet_id = "";
        this.newFiles = [];
        this.conversion_amount = "";
        this.allowedmoneytype_currency = {};
        this.saveTableConfig = [];
        this.saveTableConfigOrg = [];
        this.txn_date = new Date();
        this.expn_conv_rate_data = {};
        this.listUrls = [];
        this.updatedData = {};
        this.similarTxn = [];
        this.sucessCount = 0;
        this.failedCount = 0;
        this.splitted_fields = {};
        this.amountValue = {};
        this.claimCurrency = "";
        this.attachmentS3Url = "";
        this.txnAction = {};
        this.parsedData = {};
        this.parsedDataApiFlag = false;
        this.manualAmountApplied = false;
        this.manualMerchantApplied = false;
        this.manualDateApplied = false;
        this.manualCityApplied = false;
        this.manualCurrencyApplied = false;
        this.city = {};
        this.defaultCategory = {};
        this.currencyAlphaCodeMap = {};
        this.loaderIcon = false;
        this.deletedTxnDtls = [];
        this.bulkCreateExpenseObj = [];
    }
    _setBulkCreateExpenseObj(data, isEmit){
        this.bulkCreateExpenseObj = [...data];
        if(isEmit)
            this.emit("change", "bulkCreateExpense");
    }
    _getBulkCreateExpenseObj(){
        return this.bulkCreateExpenseObj;
    }

    _setClaimCurrency(currency) {
        this.claimCurrency = currency;
    }

    _getClaimCurrency() {
        return this.claimCurrency;
    }

    _resetClaimCurrency() {
        this.claimCurrency = "";
    }

    _clearNativeFields() {
        if (!this.parsedDataApiFlag) {
            this.description = "";
            this.wallet_id = "";
        }
        if (!this.manualAmountApplied) {
            this.currency_amount = "";
            if (!this.manualCurrencyApplied) this.currency = "";
        }
        if (!this.manualMerchantApplied) {
            this.payee_merchant = "";
        }
        if (!this.manualDateApplied) {
            this.txn_date = new Date();
        }
        if (!this.manualCityApplied) {
            this.city = {};
        }
        if (!this.manualCurrencyApplied) {
            this.currency = this._getDefaultCurrency();
        }
    }

    setParseInvoiceFlag() {
        this.parsedDataApiFlag = true;
    }

    _setManualAmountApplied(value) {
        this.manualAmountApplied = value;
    }

    _getManualAmountApplied() {
        return this.manualAmountApplied;
    }

    _setManualMerchantApplied(value) {
        this.manualMerchantApplied = value;
    }

    _getManualMerchantApplied() {
        return this.manualMerchantApplied;
    }

    _setManualDateApplied(value) {
        this.manualDateApplied = value;
    }

    _getManualDateApplied() {
        return this.manualDateApplied;
    }

    _setManualCityApplied(value) {
        this.manualCityApplied = value;
    }

    _getManualCityApplied() {
        return this.manualCityApplied;
    }

    _setManualCurrencyApplied(value) {
        this.manualCurrencyApplied = value;
    }

    _getManualCurrencyApplied() {
        return this.manualCurrencyApplied;
    }

    _clearOcrFields() {
        if (this.currency_amount !== "" && !this.manualAmountApplied) {
            this.currency_amount = "";
        }
        if (this.payee_merchant !== "" && !this.manualMerchantApplied) {
            this.payee_merchant = "";
        }
        if (
            Api._formatDate(this.txn_date, "YYYY/MM/DD") !==
                Api._formatDate(new Date(), "YYYY/MM/DD") &&
            !this.manualDateApplied
        ) {
            this.txn_date = new Date();
        }
        if (Object.keys(this.city).length > 0 && !this.manualCityApplied) {
            this.city = {};
        }
        if (this.currency !== "" && !this.manualCurrencyApplied) {
            this.currency = this._getDefaultCurrency();
        }
        // initializing the values so that it wont work if attachment is deleted
        this.parsedData = {};
        this.parsedDataApiFlag = false;
        this.emit("change", "ocr-change");
    }
    
    _clearOcrFieldCompletly(){
        this.parsedData = {};
        this.currency_amount = ""
        this.currency = this._getDefaultCurrency();
        this.parsedDataApiFlag = false;
        this.city = {};
        this.payee_merchant = "";
        this.currency_amount = "";
        this.txn_date = new Date();
        this.emit("change", "ocr-change");
    }

    listenDisputefromExpense(type) {
        this.emit("change", type);
    }

    listenExpensefromDispute(type, obj, files) {
        this.emit("change", type, obj, files);
    }

    listenAmountValue(type, disputeATMCashAmount) {
        this.amountValue = disputeATMCashAmount;
    }

    _setTxnDate(value) {
        this.txn_date = value;
        this.emit("change", "txn_date_change");
    }

    _getlistenAmountValue() {
        return this.amountValue;
    }

    _getOrgCurrencyTypes() {
        if (this.orgcurrencytypes && this.orgcurrencytypes.org_currency) {
            let tempList = [];
            if (this.orgcurrencytypes.org_currency.default_curr.length > 0) {
                tempList = [
                    this.orgcurrencytypes.org_currency.default_curr,
                    ...this.orgcurrencytypes.org_currency.other_curr_list
                ];
                if (this.claimCurrency) {
                    tempList = [...tempList, this.claimCurrency];
                }
            } else {
                tempList = [...this.orgcurrencytypes.org_currency.other_curr_list];
            }
            let allList = this.orgcurrencytypes.currency_list.filter(el => {
                if (tempList.indexOf(el.currency_code) !== -1) return true;
            });
            return allList;
        } 
            return [];
        
    }

    _setAutomationMetaData(response) {
        this.allAutomationMetaDetails = response;
        this.emit("change", "automationMetaDeatils");
    }

    _getAutomationMetaDetails() {
        return this.allAutomationMetaDetails;
    }

    _createCategoryMap(arr, obj) {
        for (let i in arr) {
            let temp = arr[i];
            if (temp && temp.id) {
                obj[temp.id] = temp.questions;
                if (temp.child && temp.child.length) {
                    this._createCategoryMap(temp.child, obj);
                }
            }
        }
        return obj;
    }

    _setCurrencyValue(currency) {
        this.currencyValue = currency;
    }

    _getCurrencyValue() {
        return this.currencyValue;
    }

    _setAnyField(type, value, splitContainer, prevSelectedCurrency) {
        if (splitContainer) {
            if (!this.splitted_fields[type]) {
                this.splitted_fields[type] = {};
            }
            this.splitted_fields[type][splitContainer] = value;
            ExtrafieldStore._triggerCompositeValue(splitContainer, type);
        } else {
            this[type] = value;
            if (type === "orgcurrencytypes") {
                let acceptedCur = [...value.org_currency.other_curr_list];
                if (value.org_currency.default_curr) {
                    acceptedCur = [value.org_currency.default_curr, ...acceptedCur];
                }
                if (Object.keys(this.transactionData).length === 0 && !this.claimCurrency)
                    this.currency = "";
                this.orgcurrencytypesMap = value.currency_list.reduce((accm, cur) => {
                    this.currencyAlphaCodeMap[cur?.alpha_code] = cur?.currency_code;
                    accm[cur.currency_code] = cur;
                    return accm;
                }, {});

                // console.log(140, prevSelectedCurrency, this.currency, acceptedCur);
                if (prevSelectedCurrency && acceptedCur.includes(this.currency)) {
                    // Do nothing as previously selected one is also in the new list
                } else if (Object.keys(this.transactionData).length === 0 && !this.claimCurrency) {
                    this.currency = "";
                } else if (Object.keys(this.transactionData).length === 0) this.currency = "";
            }
            if (type === "category" || type === "categoryTree") {
                if(type === "category"){
                    this[type] = value?.categories;
                    this.defaultCategory  = value?.defaultCategory;
                }
                this.categoryMap = this._createCategoryMap(type === "category" ? value?.categories : value, {});
            }
            if (type === "currency" && this._getDefaultCurrency() == value)
                this.conversion_amount = "";
            if (type === "confCategory") {
                this.confCategory = value;
            }
            if (type == "CONV_RATE_EXPENSE") {
                this.expn_conv_rate_data = value;
            }
            ExtrafieldStore._triggerCompositeValue("transaction", type);
            this.emit("change", type);
        }
    }

    _setAllowedMoneytype(value, id) {
        this.allowedmoneytype_currency[id] = value;
        this.emit("change", "allowedmoneytype");
    }

    _getExpnConvRate() {
        return this.expn_conv_rate_data;
    }

    _getAllowedMoneytype() {
        return this.allowedmoneytype_currency;
    }

    _saveTableConfig(value, type) {
        this.saveTableConfig[type] = value;
        this.emit("change", "saveTableConfig");
    }

    _saveTableConfigOrg(value, type){
        this.saveTableConfigOrg[type] = value;
        this.emit("change", "saveTableConfigOrg");
    }

    _getsaveTableConfigOrg(type){
        return this.saveTableConfigOrg[type];
    }

    _saveTableConfigDetails(type) {
        return this.saveTableConfig[type];
    }

    _isTableConfigExists(type) {
        return type in this.saveTableConfig;
    }

    _setMergeExpenseDailog(data) {
        this.openMergeDailogForViewDraver = data;
        this.emit("change", "openMergeDailog");
    }

    _getMergeExpenseDailog() {
        return this.openMergeDailogForViewDraver;
    }

    _getDefaultFields(content_type, viewType, isOmcOrg, sharedTxns) {
        let temp = [];
        if (content_type === "transaction") {
            temp = [
                { name: `${i18n.t("tableHeader.description")}`, value: "description_11" },
                { name: `${i18n.t("tableHeader.status")}`, value: "approval_status_1" },
                { name: `${i18n.t("tableHeader.transactionId")}`, value: "txn_id" },
                { name: `${i18n.t("tableHeader.date")}`, value: "txn_date_2" },
                { name: `${i18n.t("tableHeader.creationDate")}`, value: "created_on" },
                { name: `${i18n.t("tableHeader.merchant")}`, value: "payee_merchant_3" },
                { name: `${i18n.t("common.multiDayExpense")}`, value: "multiDayExpense" },
                { name: `${i18n.t("tableHeader.category")}`, value: "category_4" },
                {
                    name: `${i18n.t("tableHeader.txnType", {
                        name: Common._flexiDynamicData("keyWord_0", "Expense")
                    })}`,
                    value: "txn_type_19"
                },
                { name: `${i18n.t("tableHeader.city")}`, value: "city_6" },
                { name: `${i18n.t("tableHeader.cityGroup")}`, value: "city_group_7" },
                { name: `${i18n.t("tableHeader.bill")}`, value: "bill_urls_8" },
                { name: `${i18n.t("flexi.amount")}`, value: "amount_9" },
                { name: `${i18n.t("tableHeader.policyViolations")}`, value: "policy_json_11" },
                { name: `${i18n.t("tableHeader.reported")}`, value: "report_12" },
                { name: `${i18n.t("flexi.tripId")}`, value: "trip_id_1" },
                { name: `${i18n.t("tableHeader.actions")}`, value: "actions", defaultActive: true }
            ];
            if(viewType === "Employee")
                temp.splice(5, 0, { name: `${i18n.t("tableHeader.mergeExpense")}`, value: "mergeable" });
            if (Common._flexiDynamicData("hide_Common_2", "Wallet")) {
                temp.splice(5, 0, { name: `${i18n.t("flexi.wallet")}`, value: "wallet_5" });
            }
            if (viewType === "Privileged")
                temp.splice(1, 0, { name: `${i18n.t("tableHeader.user")}`, value: "user_name_10" });
            if (viewType === "Employee" && sharedTxns)
                temp.splice(1, 0, {
                    name: `${i18n.t("tableHeader.shareStatus")}`,
                    value: "share_stats_2"
                });
            if (isOmcOrg)
                temp.splice(2, 0, {
                    name: `${i18n.t("tableHeader.vehicleNo")}`,
                    value: "vehicle_13"
                });
            if (Common._flexiDynamicData("hide_Common_14", "TRF ID")) {
                temp.splice(3, 0, {
                    name: `${Common._flexiDynamicData("keyWord_2", "TRF")} ${i18n.t("flexi.id")}`,
                    value: "trf_id_1"
                });
            }
        } else if (content_type === "report") {
            if (viewType !== "Employee") {
                temp = [
                    { name: `${i18n.t("tableHeader.status")}`, value: "status_1" },
                    { name: `${i18n.t("tableHeader.lastActionedDate")}`, value: "updated_on" },
                    { name: `${i18n.t("tableHeader.creationDate")}`, value: "created_on" },
                    { name: `${i18n.t("tableHeader.submittedBy")}`, value: "requestor_2" },
                    { name: `${i18n.t("tableHeader.dateTime")}`, value: "created_on_3" },
                    { name: `${i18n.t("tableHeader.submissionDate")}`, value: "submission_date_8" },
                    { name: `${i18n.t("tableHeader.nameDescription")}`, value: "name_wf_4" },
                    {
                        name: `${i18n.t("common.noOf")} ${Common._flexiDynamicData(
                            "keyWord_0",
                            "Expense"
                        )}s`,
                        value: "transaction_count_wf"
                    },
                    {
                        name: `${i18n.t("tableHeader.verificationDate")}`,
                        value: "approved_date_7",
                        isHidden: true
                    },
                    { name: `${i18n.t("flexi.amount")}`, value: "amount_5" },
                    { name: `${i18n.t("tableHeader.approvedAmount")}`, value: "approved_amount_9" },
                    { name: `${i18n.t("tableHeader.policyViolations")}`, value: "policy_wf" },
                    {
                        name: `${i18n.t("tableHeader.actions")}`,
                        value: "actions",
                        defaultActive: true
                    },
                    {
                        name: `${Common._flexiDynamicData("keyWord_2", "TRF")} ${i18n.t(
                            "flexi.id"
                        )}`,
                        value: "trf"
                    }
                ];
                if (Common._flexiDynamicData("hide_Common_31", "Description")) {
                    temp.splice(7, 0, { name: `${i18n.t("flexi.description")}`, value: "description_10" },);
                }
                if (Common._flexiDynamicData("hide_Common_2", "Wallet")) {
                    temp.splice(7, 0, {
                        name: `${i18n.t("flexi.wallet")}`,
                        value: "wallet_name_6"
                    });
                }
                if (Common._flexiDynamicData("hide_Common_17", "Report ID")) {
                    temp.splice(3, 0, {
                        name: `${Common._flexiDynamicData("keyWord_1", "Report")} ${i18n.t(
                            "flexi.id"
                        )}`,
                        value: "report_id_2"
                    });
                }
            }
        } else if (content_type === "report_employee") {
            temp = [
                { name: `${i18n.t("tableHeader.status")}`, value: "custom_report_status_1" },
                { name: `${i18n.t("tableHeader.creationDate")}`, value: "created_on" },
                { name: `${i18n.t("tableHeader.date")}`, value: "date_3" },
                { name: `${i18n.t("tableHeader.submissionDate")}`, value: "submission_date_4" },
                { name: `${i18n.t("flexi.name")}`, value: "name_5" },
                {
                    name: `${i18n.t("common.noOf")} ${Common._flexiDynamicData(
                        "keyWord_0",
                        "Expense"
                    )}s`,
                    value: "transaction_count_7"
                },
                { name: `${i18n.t("flexi.amount")}`, value: "amount_8" },
                { name: `${i18n.t("tableHeader.policyViolations")}`, value: "policy_json" },
                { name: `${i18n.t("tableHeader.actions")}`, value: "actions", defaultActive: true },
                {
                    name: `${Common._flexiDynamicData("keyWord_2", "TRF")} ${i18n.t("flexi.id")}`,
                    value: "trf"
                }
            ];
            if (Common._flexiDynamicData("hide_Common_31", "Description")) {
                temp.splice(2, 0, { name: `${i18n.t("flexi.description")}`, value: "description_9" },);
            }
            if (Common._flexiDynamicData("hide_Common_2", "Wallet")) {
                temp.splice(6, 0, { name: `${i18n.t("flexi.wallet")}`, value: "wallet_name_6" });
            }
            if (Common._flexiDynamicData("hide_Common_17", "Report ID")) {
                temp.splice(1, 0, {
                    name: `${Common._flexiDynamicData("keyWord_1", "Report")} ${i18n.t(
                        "flexi.id"
                    )}`,
                    value: "report_id_2"
                });
            }
        } else if (content_type === "trf_history") {
            if (viewType !== "Employee")
                temp = [
                    { name: `${i18n.t("tableHeader.status")}`, value: "custom_trf_status_1" },
                    { name: `${i18n.t("tableHeader.lastActionedDate")}`, value: "updated_on" },
                    { name: `${i18n.t("tableHeader.submittedBy")}`, value: "requestor_2" },
                    { name: `${i18n.t("tableHeader.initiatedDate")}`, value: "created_on_3" },
                    { name: `${i18n.t("tableHeader.creationDate")}`, value: "created_on" },
                    { name: `${i18n.t("tableHeader.nameDescription")}`, value: "object_data_4" },
                    {
                        name: `${Common._flexiDynamicData("keyWord_2", "TRF")} ${i18n.t(
                            "flexi.id"
                        )}`,
                        value: "object_data_9"
                    },
                    {
                        name: `${Common._flexiDynamicData("keyWord_3", "Trip")}s`,
                        value: "object_data_5"
                    },
                    { name: `${i18n.t("tableHeader.requested")}`, value: "object_data_6" },
                    { name: `${i18n.t("tableHeader.approved")}`, value: "object_data_7" },
                    { name: `${i18n.t("tableHeader.reported")}`, value: "object_data_8" },
                    { name: `${i18n.t("tableHeader.policyViolations")}`, value: "policy_wf" },
                    {
                        name: `${i18n.t("tableHeader.actions")}`,
                        value: "actions",
                        defaultActive: true
                    }
                ];
        } else if (content_type === "trf") {
            temp = [
                { name: `${i18n.t("tableHeader.status")}`, value: "custom_trf_status_1" },
                { name: `${i18n.t("tableHeader.creationDate")}`, value: "created_on" },
                {
                    name: `${Common._flexiDynamicData("keyWord_2", "TRF")} ${i18n.t("flexi.name")}`,
                    value: "name_3"
                },
                {
                    name: `${Common._flexiDynamicData("keyWord_2", "TRF")} ${i18n.t("flexi.id")}`,
                    value: "trf_id_4"
                },
                {
                    name: `${Common._flexiDynamicData("keyWord_3", "Trip")}s`,
                    value: "number_of_trips_5"
                },
                { name: `${i18n.t("tableHeader.requested")}`, value: "requested_amount_base_6" },
                { name: `${i18n.t("tableHeader.approved")}`, value: "approved_amount_base_7" },
                { name: `${i18n.t("tableHeader.reported")}`, value: "is_report_attached_8" },
                { name: `${i18n.t("tableHeader.policyViolations")}`, value: "policy_json" },
                { name: `${i18n.t("tableHeader.actions")}`, value: "actions", defaultActive: true }
            ];
        } else if (content_type === "money_request_history") {
            if (viewType !== "Employee") {
                temp = [
                    { name: `${i18n.t("tableHeader.status")}`, value: "status_1" },
                    { name: `${i18n.t("tableHeader.lastActionedDate")}`, value: "updated_on" },
                    { name: `${i18n.t("tableHeader.approvedDate")}`, value: "approved_date_14" },
                    { name: `${i18n.t("tableHeader.requestedDate")}`, value: "created_on" },
                    { name: `${i18n.t("tableHeader.submittedBy")}`, value: "requestor_3" },
                    { name: `${i18n.t("tableHeader.reasons")}`, value: "reason_4" },
                    { name: `${i18n.t("tableHeader.requestedAmount")}`, value: "req_amount_6" },
                    { name: `${i18n.t("tableHeader.approvedAmount")}`, value: "appr_amount_7" },
                    { name: `${i18n.t("tableHeader.bill")}`, value: "twf_id_8" },
                    {
                        name: `${i18n.t("tableHeader.requestID")}`,
                        value: "req_id-9",
                        isHidden: true
                    },
                    {
                        name: `${Common._flexiDynamicData("keyWord_3", "Trip")} ${i18n.t(
                            "flexi.name"
                        )}`,
                        value: "trip_name-10",
                        isHidden: true
                    },
                    {
                        name: `${Common._flexiDynamicData("keyWord_3", "Trip")} ${i18n.t(
                            "flexi.duration"
                        )}`,
                        value: "trip_description-11",
                        isHidden: true
                    },
                    {
                        name: `${i18n.t("lbl.fromDate")}`,
                        value: "trip_start_date-12",
                        isHidden: true
                    },
                    { name: `${i18n.t("lbl.toDate")}`, value: "trip_end_date-13", isHidden: true },
                    { name: `${i18n.t("tableHeader.attachment")}`, value: "req_id_14" },
                    { name: `${i18n.t("tableHeader.policyViolations")}`, value: "policy_json" },
                    { name: `${i18n.t("tableHeader.actions")}`, value: "actions", defaultActive: true }
                ];
                if (Common._flexiDynamicData("hide_Common_2", "Wallet")) {
                    temp.splice(5, 0, { name: `${i18n.t("flexi.wallet")}`, value: "wallet_5" });
                }
            }
        } else if (content_type === "money_request") {
            if (viewType !== "Employee") {
                temp = [
                    { name: `${i18n.t("tableHeader.status")}`, value: "status_1" },
                    //    {name:'Requested Date',value:'req_date_3'},
                    { name: `${i18n.t("tableHeader.approvedDate")}`, value: "approved_date_8" },
                    { name: `${i18n.t("tableHeader.requestedDate")}`, value: "created_on" },
                    { name: `${i18n.t("tableHeader.submittedBy")}`, value: "requestor_2" },
                    { name: `${i18n.t("tableHeader.reasons")}`, value: "reason_4" },
                    { name: `${i18n.t("tableHeader.requestedAmount")}`, value: "req_amt_6" },
                    { name: `${i18n.t("tableHeader.approvedAmount")}`, value: "appr_amt_7" },
                    { name: `${i18n.t("genericWF.mrId")}`, value: "mr_id", isHidden: true },
                    {
                        name: `${Common._flexiDynamicData("keyWord_3", "Trip")} ${i18n.t(
                            "flexi.name"
                        )}`,
                        value: "trip_name",
                        isHidden: true
                    },
                    {
                        name: `${Common._flexiDynamicData("keyWord_3", "Trip")} ${i18n.t(
                            "flexi.duration"
                        )}`,
                        value: "trip_description",
                        isHidden: true
                    },
                    { name: `${i18n.t("lbl.fromDate")}`, value: "trip_start_date", isHidden: true },
                    { name: `${i18n.t("lbl.toDate")}`, value: "trip_end_date", isHidden: true },
                    {
                        name: `${i18n.t("tableHeader.actions")}`,
                        value: "actions",
                        defaultActive: true
                    }
                ];

                if (Common._flexiDynamicData("hide_Common_2", "Wallet")) {
                    temp.splice(9, 0, { name: `${i18n.t("flexi.wallet")}`, value: "wallet_7" });
                }
            } else {
                temp = [
                    { name: `${i18n.t("tableHeader.status")}`, value: "status_1" },
                    { name: `${i18n.t("tableHeader.date")}`, value: "req_date_2" },
                    { name: `${i18n.t("tableHeader.actionedDate")}`, value: "approved_date_3" },
                    { name: `${i18n.t("tableHeader.reasons")}`, value: "reason_4" },
                    { name: `${i18n.t("tableHeader.requested")}`, value: "req_amt_6" },
                    { name: `${i18n.t("tableHeader.approved")}`, value: "appr_amt_7" },
                    { name: `${i18n.t("tableHeader.bill")}`, value: "req_id_8" },
                    { name: `${i18n.t("tableHeader.policyViolations")}`, value: "policy_json" },
                    {
                        name: `${i18n.t("tableHeader.actions")}`,
                        value: "actions",
                        defaultActive: true
                    }
                ];
                if (Common._flexiDynamicData("hide_Common_2", "Wallet")) {
                    temp.splice(4, 0, { name: `${i18n.t("flexi.wallet")}`, value: "wallet_5" });
                }
            }
        } else if (content_type === "wallet") {
            temp = [
                { name: `${i18n.t("tableHeader.user")}`, value: "native-user" },
                { name: `${i18n.t("tableHeader.status")}`, value: "native-status" },
                { name: `${i18n.t("tableHeader.actions")}`, value: "actions", defaultActive: true }
            ];
            if (Common._flexiDynamicData("hide_Priv_13", "Load Wallet")) {
                temp.splice(4, 0, {
                    name: `${i18n.t("flexi.loadWallet")}`,
                    value: "native-load_money"
                });
            }
            if (Common._flexiDynamicData("hide_Priv_14", "Withdraw Wallet")) {
                temp.splice(5, 0, {
                    name: `${i18n.t("flexi.withdrawWallet")}`,
                    value: "native-withdraw_money"
                });
            }
            if (Common._flexiDynamicData("hide_Priv_15", "Wallet Name")) {
                temp.splice(3, 0, {
                    name: `${i18n.t("flexi.walletName")}`,
                    value: "native-wallet_name"
                });
            }
            if (Common._flexiDynamicData("hide_Priv_16", "balance")) {
                temp.splice(2, 0, {
                    name: `${i18n.t("flexi.balance")}`,
                    value: "native-trans_limit"
                });
            }
        } else if (content_type === "pending_on_me_report") {
            temp = [
                { name: `${i18n.t("tableHeader.status")}`, value: "reportstatus_1" },
                { name: `${i18n.t("tableHeader.lastActionedDate")}`, value: "updated_on" },
                { name: `${i18n.t("tableHeader.submittedBy")}`, value: "submitted_by_3" },
                { name: `${i18n.t("tableHeader.dateTime")}`, value: "report_date_4" },
                { name: `${i18n.t("tableHeader.creationDate")}`, value: "created_on" },
                { name: `${i18n.t("tableHeader.submissionDate")}`, value: "submission_date_8" },
                { name: `${i18n.t("tableHeader.nameDescription")}`, value: "name_decs_5" },
                {
                    name: `${i18n.t("common.noOf")} ${Common._flexiDynamicData(
                        "keyWord_0",
                        "Expense"
                    )}s`,
                    value: "transaction_count_8"
                },
                { name: `${i18n.t("flexi.amount")}`, value: "amount_6" },
                { name: `${i18n.t("tableHeader.approvedAmount")}`, value: "approved_amount_10" },
                { name: `${i18n.t("tableHeader.policyViolations")}`, value: "policy_report_9" },
                {
                    name: `${Common._flexiDynamicData("keyWord_2", "TRF")} ${i18n.t("flexi.id")}`,
                    value: "trf"
                },
                { name: `${i18n.t("tableHeader.action")}`, value: "actions", defaultActive: true }
            ];
            if (Common._flexiDynamicData("hide_Common_31", "Description")) {
                temp.splice(6, 0, { name: `${i18n.t("flexi.description")}`, value: "description_11" });
            }
            if (Common._flexiDynamicData("hide_Common_2", "Wallet")) {
                temp.splice(7, 0, { name: `${i18n.t("flexi.wallet")}`, value: "wallet_name_7" });
            }
            if (Common._flexiDynamicData("hide_Common_17", "Report ID")) {
                temp.splice(2, 0, {
                    name: `${Common._flexiDynamicData("keyWord_1", "Report")} ${i18n.t(
                        "flexi.id"
                    )}`,
                    value: "resource_id_2"
                });
            }
        } else if (content_type === "pending_on_me_trf") {
            temp = [
                { name: `${i18n.t("tableHeader.status")}`, value: "custom_trf_status_1" },
                { name: `${i18n.t("tableHeader.lastActionedDate")}`, value: "updated_on" },
                { name: `${i18n.t("tableHeader.submittedBy")}`, value: "requestor_2" },
                { name: `${i18n.t("tableHeader.dateTime")}`, value: "created_on_3" },
                { name: `${i18n.t("tableHeader.creationDate")}`, value: "created_on" },
                { name: `${i18n.t("tableHeader.nameDescription")}`, value: "object_data_4" },
                {
                    name: `${Common._flexiDynamicData("keyWord_2", "TRF")} ${i18n.t("flexi.id")}`,
                    value: "object_data_5"
                },
                {
                    name: `${Common._flexiDynamicData("keyWord_3", "Trip")}s`,
                    value: "object_data_55"
                },
                { name: `${i18n.t("tableHeader.requested")}`, value: "object_data_6" },
                { name: `${i18n.t("tableHeader.approved")}`, value: "object_data_7" },
                { name: `${i18n.t("tableHeader.reported")}`, value: "object_data_8" },
                { name: `${i18n.t("flexi.policyTrf")}`, value: "object_data_9" },
                { name: `${i18n.t("tableHeader.action")}`, value: "actions", defaultActive: true }
            ];
        } else if (content_type === "pending_on_me_money_request") {
            temp = [
                { name: `${i18n.t("tableHeader.status")}`, value: "native-status" },
                { name: `${i18n.t("tableHeader.lastActionedDate")}`, value: "updated_on" },
                { name: `${i18n.t("tableHeader.submittedBy")}`, value: "native-requestor" },
                { name: `${i18n.t("tableHeader.approvedDate")}`, value: "native-approved_date" },
                { name: `${i18n.t("tableHeader.requestedDate")}`, value: "native-created_on" },
                { name: `${i18n.t("tableHeader.nameDescription")}`, value: "native-desc" },
                { name: `${i18n.t("tableHeader.requestedAmount")}`, value: "native-req-amount" },
                { name: `${i18n.t("tableHeader.approvedAmount")}`, value: "native-appr-amount" },
                {
                    name: `${i18n.t("tableHeader.moneyRequestId")}`,
                    value: "native-resourceId",
                    isHidden: true
                },
                {
                    name: `${Common._flexiDynamicData("keyWord_3", "Trip")} ${i18n.t(
                        "flexi.name"
                    )}`,
                    value: "native-trip_name",
                    isHidden: true
                },
                {
                    name: `${Common._flexiDynamicData("keyWord_3", "Trip")} ${i18n.t(
                        "flexi.duration"
                    )}`,
                    value: "native-trip_description",
                    isHidden: true
                },
                {
                    name: `${i18n.t("lbl.fromDate")}`,
                    value: "native-trip_start_date",
                    isHidden: true
                },
                { name: `${i18n.t("lbl.toDate")}`, value: "native-trip_end_date", isHidden: true },
                { name: `${i18n.t("tableHeader.bill")}`, value: "native-bill" },
                { name: `${i18n.t("tableHeader.policyViolations")}`, value: "native-policy" },
                { name: `${i18n.t("tableHeader.action")}`, value: "actions", defaultActive: true }
            ];

            if (Common._flexiDynamicData("hide_Common_2", "Wallet")) {
                temp.splice(9, 0, { name: `${i18n.t("flexi.wallet")}`, value: "native-wallet" });
            }
        } else if (content_type === "pending_on_me_card_load") {
            temp = [
                { name: `${i18n.t("tableHeader.status")}`, value: "status" },
                { name: `${i18n.t("tableHeader.requestedDate")}`, value: "req_date" },
                { name: `${i18n.t("tableHeader.approvedDate")}`, value: "approved_date" },
                { name: `${i18n.t("tableHeader.submittedBy")}`, value: "submitted_by" },
                { name: `${i18n.t("tableHeader.inFavourOf")}`, value: "in_favor_of" },
                { name: `${i18n.t("genericWF.reason")}`, value: "reason" },
                { name: `${i18n.t("tableHeader.requestedAmount")}`, value: "req_amt" },
                { name: `${i18n.t("tableHeader.approvedAmount")}`, value: "appr_amt" },
                { name: `${i18n.t("tableHeader.requestID")}`, value: "request_id", isHidden: true },
                { name: `${i18n.t("tableHeader.policyViolations")}`, value: "policy_json" },
                { name: `${i18n.t("tableHeader.action")}`, value: "actions", defaultActive: true }
            ];

            if (Common._flexiDynamicData("hide_Common_2", "Wallet")) {
                temp.splice(6, 0, { name: `${i18n.t("flexi.wallet")}`, value: "wallet" });
            }
        } else if (content_type === "card_load_history") {
            temp = [
                { name: `${i18n.t("tableHeader.status")}`, value: "status" },
                { name: `${i18n.t("tableHeader.requestedDate")}`, value: "req_date" },
                { name: `${i18n.t("tableHeader.approvedDate")}`, value: "appr_date" },
                { name: `${i18n.t("tableHeader.submittedBy")}`, value: "submitted_by" },
                { name: `${i18n.t("tableHeader.inFavourOf")}`, value: "targetUser" },
                { name: `${i18n.t("tableHeader.approver")}`, value: "approver" },
                { name: `${i18n.t("genericWF.reason")}`, value: "reason" },
                { name: `${i18n.t("tableHeader.requestedAmount")}`, value: "req_amount" },
                { name: `${i18n.t("tableHeader.approvedAmount")}`, value: "appr_amount" },
                { name: `${i18n.t("tableHeader.requestID")}`, value: "request_id", isHidden: true },
                { name: `${i18n.t("tableHeader.policyViolations")}`, value: "policy_json" },
                { name: `${i18n.t("tableHeader.action")}`, value: "actions", defaultActive: true }
            ];

            if (Common._flexiDynamicData("hide_Common_2", "Wallet")) {
                temp.splice(7, 0, { name: `${i18n.t("flexi.wallet")}`, value: "wallet" });
            }
        } else if (content_type === "mobile_report_pending_employee") {
            temp = [
                { name: `${i18n.t("tableHeader.status")}`, value: "report_status_1" },
                // { name: `${i18n.t("flexi.reportId")}`, value: "report_id_7" },
                {
                    name: `${i18n.t("tableHeader.verificationDate")}`,
                    value: "approved_date_6",
                    isHidden: true
                },
                { name: `${i18n.t("tableHeader.creationDate")}`, value: "created_on" },
                { name: `${i18n.t("tableHeader.dateTime")}`, value: "date_2" },
                { name: `${i18n.t("tableHeader.submissionDate")}`, value: "submission_date_8" },
                { name: `${i18n.t("tableHeader.submittedBy")}`, value: "requestor" },
                { name: `${i18n.t("tableHeader.nameDescription")}`, value: "name_3" },
                {
                    name: `${i18n.t("common.noOf")} ${Common._flexiDynamicData(
                        "keyWord_0",
                        "Expense"
                    )}s`,
                    value: "transaction_count_6"
                },
                { name: `${i18n.t("flexi.amount")}`, value: "amount_4" },
                { name: `${i18n.t("tableHeader.approvedAmount")}`, value: "approved_amount_10" },
                { name: `${i18n.t("tableHeader.policyViolations")}`, value: "policy_report_8" },
                {
                    name: `${Common._flexiDynamicData("keyWord_2", "TRF")} ${i18n.t("flexi.id")}`,
                    value: "trf"
                },
                { name: `${i18n.t("tableHeader.action")}`, value: "actions", defaultActive: true }
            ];
            if (Common._flexiDynamicData("hide_Common_31", "Description")) {
                temp.splice(6, 0, { name: `${i18n.t("flexi.description")}`, value: "description_11" });
            }
            if (Common._flexiDynamicData("hide_Common_2", "Wallet")) {
                temp.splice(7, 0, { name: `${i18n.t("flexi.wallet")}`, value: "wallet_name_5" });
            }
            if (Common._flexiDynamicData("hide_Common_17", "Report ID")) {
                temp.splice(1, 0, {
                    name: `${Common._flexiDynamicData("keyWord_1", "Report")} ${i18n.t(
                        "flexi.id"
                    )}`,
                    value: "report_id_7"
                });
            }
        } else if (content_type === "mobile_trf_pending_employee") {
            temp = [
                { name: `${i18n.t("tableHeader.status")}`, value: "custom_trf_status_1" },
                { name: `${i18n.t("tableHeader.dateTime")}`, value: "created_on_2" },
                { name: `${i18n.t("tableHeader.creationDate")}`, value: "created_on" },
                { name: `${i18n.t("tableHeader.submittedBy")}`, value: "requestor" },
                { name: `${i18n.t("tableHeader.nameDescription")}`, value: "name_3" },
                {
                    name: `${Common._flexiDynamicData("keyWord_3", "Trip")} ${i18n.t("flexi.id")}`,
                    value: "trf_id_44"
                },
                {
                    name: `${Common._flexiDynamicData("keyWord_3", "Trip")}s`,
                    value: "number_of_trips_4"
                },
                { name: `${i18n.t("tableHeader.requested")}`, value: "requested_amount_base_6" },
                { name: `${i18n.t("tableHeader.approved")}`, value: "approved_amount_base_7" },
                { name: `${i18n.t("tableHeader.reported")}`, value: "is_report_attached_5" },
                { name: `${i18n.t("flexi.policyTrf")}`, value: "policy_json_8" },
                { name: `${i18n.t("tableHeader.action")}`, value: "actions", defaultActive: true }
            ];
        }
        else if(content_type === "workflow-transaction_report_expenses"){
            temp = [
                { name: `${i18n.t("tableHeader.approvalStatus")}`, value: "native-approval_status" },
                { name: `${i18n.t("tableHeader.shareStatus")}`, value: "share_stats_2" },
                { name: `${i18n.t("tableHeader.transactionId")}`, value: "txn_id" },
                {
                    name: `${i18n.t("tableHeader.txnDate", {
                        timezone: `(${Common._getTimeZoneAbbr()})`
                    })}`,
                    value: "native-txn_date"
                },
                {
                    name: `${i18n.t("tableHeader.creationDate", {
                        timezone: `(${Common._getTimeZoneAbbr()})`
                    })}`,
                    value: "created_on",
                    title: `${i18n.t("tableHeader.creationDate", {
                        timezone: `(${Common._getTimeZoneAbbr()})`
                    })}`
                },
                { name: `${i18n.t("tableHeader.payeeMerchant")}`, value: "native-payee_merchant" },
                { name: `${i18n.t("flexi.description")}`, value: "native-description" },
                { name: `${i18n.t("tableHeader.txn_Type")}`, value: "txn_type-4", isHidden: true },
                { name: `${i18n.t("tableHeader.billUrls")}`, value: "bill_urls-5" },
                { name: `${i18n.t("tableHeader.category")}`, value: "native-category" },
                { name: `${i18n.t("tableHeader.city")}`, value: "city-8", isHidden: true },
                { name: `${i18n.t("tableHeader.city_group")}`, value: "city_group-9", isHidden: true },
                { name: `${i18n.t("tableHeader.requestedAmount")}`, value: "native-requested_amount" },
                { name: `${i18n.t("flexi.approvedAmount")}`, value: "native-approved_amount" },
                { name: `${i18n.t("tableHeader.policyViolations")}`, value: "native-policy_json" },
                { name: `${i18n.t("tableHeader.actions")}`, value: "actions", defaultActive: true },
                { name: `${i18n.t("tableHeader.parent")}`, value: "native-approval_parent" },
                { name: `${i18n.t("common.multiDayExpense")}`, value: "multiDayExpense" },
            ];
            if (Common._flexiDynamicData("hide_Common_2", "Wallet")) {
                temp.splice(6, 0, { name: "wallet", value: "wallet-6", isHidden: true });
            }
        }

        else if(content_type === "workflow-trip-transaction") {
            temp = [
                { name: "Date", value: "tripDate" },
                { name: `${Common._flexiDynamicData("keyWord_3", "Trip")}`, value: "tripId" },
                { name: "Line Item", value: "line_item" },
                { name: "Merchant", value: "trmerchant" },
                { name: "Attachment", value: "expense-bill" },
                { name: "Policy Violations ", value: "native-policy_json" },
                { name: "Amount", value: "amt" },
                { name: "Added By", value: "addedBy" },
                { name: "Actions", value: "action", defaultActive: true }
            ];
        }

        return temp;
    }

    _formatTRFColumnId(row, fromPage) {
        if (row && row.trf) {
            return (
                <span className="trfHyperLink" onClick={this._onClickTrfId.bind(this, row)}>
                    {row.trf}
                </span>
            );
        } else if (
            ["pending", "history"].indexOf(fromPage) !== -1 &&
            row.object_data &&
            row.object_data.trf
        ) {
            return (
                <span
                    className="trfHyperLink"
                    onClick={this._onClickTrfId.bind(this, row.object_data)}
                >
                    {row.object_data.trf}
                </span>
            );
        } 
            return "-";
        
    }

    _onClickTrfId(row, event) {
        event.stopPropagation();
        history.push(`/genericworkflow/${Mapper.TRF}/${row.trf}`);
    }

    _setTransactionData(value = {}, notEmit) {
        if (value && "city" in value) {
            const city_obj = {};
            const city_name = value && value.city.display_name;
            city_obj.id = (value && value.city.id) || "";
            city_obj.name = city_name;
            this.city = city_obj;
        }
        this.transactionData = value;
        this.currency_amount = value?.transaction?.currency_amount;
        this.currency = value?.transaction?.currency;
        this.payee_merchant = value?.transaction?.payee_merchant;
        this.wallet_id = value?.transaction?.wallet?.id;
        this.description = value?.transaction?.description;
        this.txn_date = value?.transaction?.txn_date || new Date();
        if(!notEmit)
            this.emit("change", "txn_data");
    }

    _getTransactionData() {
        return this.transactionData;
    }

    _clearTransactionData() {
        this.transactionData = {};
    }

    _getDefaultId() {
        for (let i in this.expensetypes) {
            if (this.expensetypes[i].type_identifier == "N-HPCTU")
                return this.expensetypes[i].id + "";
        }
        return "";
    }

    _getDefaultCurrency(isCurSet) {
        if(isCurSet){
            if(this.orgcurrencytypes?.default_currency?.currency_code){
                return this.orgcurrencytypes?.default_currency?.currency_code;
            } else if (
                this.orgcurrencytypes &&
                this.orgcurrencytypes.org_currency &&
                this.orgcurrencytypes.org_currency.default_curr
            ) {
                return this.orgcurrencytypes.org_currency.default_curr;
            } else {
               return this.orgcurrencytypes?.org_currency?.other_curr_list[0];
            }
            return "";
        }
        const defCurr = UserInfoStores.getDefaultCurrency(true);
        return this.currencyAlphaCodeMap?.[defCurr];
    }

    _getCurrencyName(code) {
        return this.orgcurrencytypesMap[code];
    }

    _getOrgCurrencyTypesMap() {
        return this.orgcurrencytypesMap;
    }

    _getAnyField(type, splitContainer) {
        if (splitContainer && splitContainer.includes("split")) {
            return (this.splitted_fields[type] && this.splitted_fields[type][splitContainer]) || "";
        } 
            return this[type];
        
    }

    _setUrls(data) {
        this.listUrls = data;
        this.emit("change", "BillAttachmentSuccess");
    }

    _getUrls() {
        return this.listUrls;
    }

    _setDraftUpdateData(data) {
        this.updatedData = data;
        this.emit("change", "draftUpdateData");
    }

    _getDraftUpdateData() {
        return this.updatedData;
    }

    _setDraftSimilarTxn(data) {
        this.similarTxn = data;
        this.emit("change", "draftSimilarTxnData");
    }

    _getDraftSimilarTxn() {
        return this.similarTxn;
    }

    _setDraftBulkUpload(data, name) {
        this.sucessCount = data;
        this.sucessName = name;
        this.emit("change", "draftBillCounter");
    }

    _getDraftBulkUpload() {
        return this.sucessCount;
    }

    _getBulkSucessName() {
        return this.sucessName;
    }

    _setDraftBulkFailed(data, name) {
        this.failedCount = data;
        this.failedName = name;
        this.emit("change", "draftBillFailedCounter");
    }

    _getDraftBulkFailed() {
        return this.failedCount;
    }

    _getBulkFailedName() {
        return this.failedName;
    }

    _setMeargeData(data, type) {
        this.setMerageData = data;
        this.emit("change", type);
    }

    _getMeargeData() {
        return this.setMerageData;
    }

    _setDisputeReason(value) {
        this.disputeReason = value;
        this.emit("change", "disputeReason");
    }

    _getDisputeReason() {
        return this.disputeReason;
    }

    _setAttachmentS3Url(data) {
        let temp = this.listUrls;
        if (temp && temp.bill_urls && temp.bill_urls.length) {
            data &&
                data.bill_urls &&
                data.bill_urls.forEach(element => {
                    temp.bill_urls.unshift(element);
                });
            // temp.bill_urls.push(data.bill_urls[0]);
        } else {
            temp["bill_urls"] = data.bill_urls;
        }
        this.listUrls = temp;
        this.emit("change", "BillAttachmentSuccess");
    }

    _removeBilUrl(type, data) {
        const newArr = this.listUrls.bill_urls.filter(e => e !== data.url);
        if (newArr && newArr.length) this.listUrls["bill_urls"] = newArr;
        else this.listUrls = [];
        this.emit("change", type);
    }

    _setTxnAction(data, type) {
        this.txnAction = data;
        this.emit("change", type);
    }

    _getTxnAction() {
        return this.txnAction;
    }
   
    setLoaderIcon(loader) {
        this.loaderIcon = loader;
        this.emit("change", "creationStepper");
    }

    getLoaderIcon() {
        return this.loaderIcon;
    }

    _setParsedData(value, tempIndex, fromBulkCreate, fromWebUtil, fromImagePart) {
        const tempValue = Common._perfectClone(value);
        // const tempData = [...this._getBulkCreateExpenseObj()];
        const index = +window?.location?.search?.split("=")?.[2];
        if(index == 0 || index || fromBulkCreate){
            const bulkCreateArr = this._getBulkCreateExpenseObj()?.[index];
            this._setTransactionData(value, true);
            if(bulkCreateArr?.istxnCompleted){
                ExtrafieldStore._initExtraFieldRunningMapValues("transaction", value?.transaction?.txn_type?.id, true)
                // ExtrafieldStore.categoryDependentDDRunningMap("", "transaction");
                this.emit("change", "setEFValueBulkCreate");
            } else {
                ExtrafieldStore._flushExtraFieldRunningMapValues("transaction");
                // ExtrafieldStore._resetExpressionExtraField();
                ExtrafieldStore._getAllExtraFieldsNew(ExtrafieldStore._getextraFields("transaction"), "transaction");
            }
            this._setManualAmountApplied(false);
            this._clearOcrFields();
        }
        this.parsedData = value;
        value = value?.transaction || [];
        if (
            this.currency_amount === "" &&
            value &&
            "currency_amount" in value &&
            !this.manualAmountApplied
        ) {
            this.currency_amount = (+value?.currency_amount)?.toFixed(2);
        }
        if (
            this.payee_merchant === "" &&
            value &&
            "payee_merchant" in value &&
            !this.manualMerchantApplied
        ) {
            this.payee_merchant = value?.payee_merchant;
        }
        if (
            Api._formatDate(this.txn_date, "YYYY/MM/DD") ===
                Api._formatDate(new Date(), "YYYY/MM/DD") &&
            value &&
            "txn_date" in value &&
            !this.manualDateApplied
        ) {
            this.txn_date = new Date(Api._formatDate(value?.txn_date, "YYYY/MM/DD HH:mm:ss"));
        }
        if (
            !Object.keys(this.city).length &&
            value &&
            "city" in value &&
            value.city !== null &&
            !this.manualCityApplied
        ) {
            const city_obj = {};
            const city_name = value?.city?.display_name;
            city_obj.id = value?.city?.id || "";
            city_obj.name = city_name;
            this.city = city_obj;
        }
        if (
            this.currency === "" &&
            value &&
            "currency" in value &&
            !this.manualCurrencyApplied &&
            this._checkForValidCurrency(value.currency)
        ) {
            this.currency = value.currency;
        }
        if(tempIndex === 0 || tempIndex || fromWebUtil) {
            const tempBulkCreate = [...this._getBulkCreateExpenseObj()];
            if(tempBulkCreate?.[tempIndex]){
                tempBulkCreate[tempIndex].isDataFetched = fromWebUtil ? true : tempBulkCreate[tempIndex]?.isDataFetched;
                tempBulkCreate[tempIndex].txnDtl = Common._perfectClone(tempValue);
                this._setBulkCreateExpenseObj(tempBulkCreate, true);
                    const elem = document.getElementById("transaction");
                    elem.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
            }
        }
        if(!index || fromBulkCreate || fromImagePart) 
            this.emit("change", "attachment_parsed");
    }
    _getParsedData() {
        return this.parsedData;
    }
    _checkForValidCurrency(currency) {
        const {
            org_currency: { default_curr, other_curr_list = [] } = {}
        } = this.orgcurrencytypes;
        return [default_curr, ...other_curr_list].includes(currency);
    }
    defaultFieldsPayroll() {
        let temp = [
            { name: `${i18n.t("tableHeader.transactionId")}`, value: "txn_id" },
            { name: `${i18n.t("tableHeader.date")}`, value: "txn_date_2" },
            { name: `${i18n.t("tableHeader.merchant")}`, value: "payee_merchant_3" },
            { name: `${i18n.t("tableHeader.description")}`, value: "description_11" },
            { name: `${i18n.t("flexi.wallet")}`, value: "wallet_5" },
            {
                name: `${i18n.t("tableHeader.txnType", {
                    name: Common._flexiDynamicData("keyWord_0", "Expense")
                })}`,
                value: "txn_type_19"
            },
            { name: `${i18n.t("flexi.amount")}`, value: "amount_9" },
            { name: `${i18n.t("tableHeader.actions")}`, value: "actions", defaultActive: true }
        ];
        return temp;
    }
    _setBulkCreate(data){
        const tempData = [...this._getBulkCreateExpenseObj()];
        const index = +window?.location?.search?.split("=")?.[2];

        tempData[index].istxnCompleted = true;
        tempData[index].isDataFetched = true;
        tempData[index].txnId = data?.txn_id;
        tempData[index].wallet = data?.wallet;
        const billUrls = tempData[index]?.txnDtl?.transaction?.bill_urls;
        const { extra_field, ...rest } = data;
        tempData[index].txnDtl.transaction = rest;
        tempData[index].txnDtl.transaction.bill_urls = billUrls;
        if(extra_field?.extra_fields?.[data?.txn_id] )
            tempData[index].txnDtl.extra_field = extra_field?.extra_fields?.[data?.txn_id] 
        this._setBulkCreateExpenseObj(tempData, true);
        this._checkBulkTxnCreated(tempData, (index + 1));
        // if(tempData?.length - 1 !== +index){
        //     history.push({
        //         pathname: location?.pathname,
        //         search: `?bulkCreate=true&txnIndex=${+index + 1}`,
        //     })
        //     this._setParsedData(tempData[+index + 1].txnDtl, +index + 1, true);
        //     // ExtrafieldStore._flushExtraFieldRunningMapValues("transaction");
        //     // ExpenseStores.initData();
        //     // ExtrafieldStore._flushExtraFieldRunningMapValues();
        //     // const reqObj = {
        //     //     resource_name: "transaction",
        //     //     has_role: Api._getKey("viewType")
        //     // };
        //     // ExtraFieldAction.getAllExtraField(reqObj);
        //     this.emit("change", "txnIndex")
        // } else {
        //     this.emit("change", "bukCreateLastExpene")
        // }
    }
    _checkBulkTxnCreated = (tempData, tempIndex) => {
        let notCompletedTxnIndex = null;
        for(let i = tempIndex ; i < tempData.length ; i++) {
            if(!tempData[i]?.istxnCompleted){
                notCompletedTxnIndex = i;
                break;
            }
        }
        if(notCompletedTxnIndex === null) {
            for(let i = 0 ; i < tempData.length ; i++) {
                if(!tempData[i]?.istxnCompleted){
                    notCompletedTxnIndex = i;
                    break;
                }
            }
        }
        if(notCompletedTxnIndex !== null){
            history.push({
                pathname:  window?.location?.pathname,
                search: `?bulkCreate=true&txnIndex=${notCompletedTxnIndex}`,
            })
            this._setParsedData(tempData[+notCompletedTxnIndex]?.txnDtl, +notCompletedTxnIndex, true);
            this.emit("change", "txnIndex")
        } else {
            this.getBulkLastExpenseEmit()
        }
    }
    getBulkLastExpenseEmit(){
        this.emit("change", "bukCreateLastExpene");
    }
    setparseFailed(value, index){
        if(index === 0 || index) {
            const tempBulkCreate = [...this._getBulkCreateExpenseObj()];
            tempBulkCreate[index].isDataFetched = "failed";
            tempBulkCreate[index].txnDtl = [];
            this._setBulkCreateExpenseObj(tempBulkCreate, true);
            this._setParsedData(tempBulkCreate[index].txnDtl, index, null, null);
        }
        this.emit("change", "attachmentParseFail");

    }
    _setDeletedTxnDtls(type, data) {
        this.deletedTxnDtls = data;
        this.emit("change", type)
    }
    _getDeletedTxnDtls(){
        return this.deletedTxnDtls;
    }
    _handleActions(action) {
        switch (action.type) {
            case "SET_EXPENSE_TYPE": {
                this._setAnyField("expensetypes", Common._sortDropdown(action.txn_type, "name"));
                break;
            }
            case "SET_EXPENSE_TYPE_ID": {
                this._setAnyField(
                    "transactionTypeId",
                    Common._sortDropdown(action.txn_type, "name")
                );
                break;
            }
            case "ALL_TXN_TYPE": {
                this._setAnyField("allTxnType", Common._sortDropdown(action.all_txn_type, "name"));
                break;
            }
            case "ALL_NON_FIN_TXN_TYPE": {
                this._setAnyField(
                    "allNonFinTxnType",
                    Common._sortDropdown(action.all_non_fin_txn_type, "name")
                );
                break;
            }
            case "SET_CATEGORY": {
                this._setAnyField(
                    "category",
                    {
                        categories: Common._sortNestedDropdown(action?.category?.categories, "name", "child"),
                        defaultCategory: action?.category?.default_category
                    }
                );
                break;
            }
            case "SET_CATEGORY_TREE": {
                this._setAnyField(
                    "categoryTree",
                    Common._sortNestedDropdown(action.categoryTree, "name", "child")
                );
                // this.emit('change','categoryTree');
                break;
            }
            case "SET_CATEGORY_MCC": {
                this._setAnyField("categoryMCC", action.categoryMCC);
                break;
            }
            case "REPORT_AUTOMATION_META_DETAILS": {
                this._setAutomationMetaData(action.response);
                break;
            }
            case "ADD_CATEGORY": {
                let list = this.category;
                list.push(action.category);
                this._setAnyField("category", list);
                break;
            }
            case "SET_ORG_CURRENCY_TYPE": {
                this._setAnyField(
                    "orgcurrencytypes",
                    action.currency_type,
                    false,
                    action.prevSelectedCurrency
                );
                break;
            }
            case "SET_CURRENCY_TYPE": {
                this._setAnyField("currencytypes", action.currency_type);
                break;
            }
            case "ALLOWED_MONEYTYPE_CURRENCY": {
                this._setAllowedMoneytype(action.response, action.tecId);
                break;
            }
            case "SAVE_TABLE_CONFIG": {
                this._saveTableConfig(action.response, action.content_type);
                break;
            }
            case "SAVE_TABLE_CONFIG_POST": {
                this.emit("change", "saveTableConfigPost");
                break;
            }
            case "SAVE_TABLE_CONFIG_ORG": {
                this._saveTableConfigOrg(action.response, action.content_type)
            }
            case "ERROR_MSG": {
                this._setAnyField("errMsg", action.value);
                break;
            }
            case "SINGLE_TRANSACTION": {
                this._setTransactionData(action.txn_data);
                break;
            }
            case "SINGLE_TRANSACTION_FAIL": {
                this.emit("change", "txn_data_fail");
                break;
            }
            case "COMPUTE_NOW": {
                this.emit("change", "compute");
                break;
            }
            case "BILL_DELETION_SUCCESS": {
                this.emit("change", "BillDeletionSuccess");
                break;
            }
            case "CLEAR_ALL": {
                this.initData();
                break;
            }
            case "CONFIF_CATEGORY": {
                this._setAnyField("confCategory", action.categoryConf);
                break;
            }
            case "CONV_RATE_EXPENSE": {
                this._setAnyField("CONV_RATE_EXPENSE", action.response);
                break;
            }
            case "BILL_ATTACHMENT_EMIT": {
                this._setUrls(action.response);
                break;
            }
            case "draftDelete": {
                this.emit("change", "draftDelete");
                break;
            }
            case "UPDATE_DRAFT": {
                this._setDraftUpdateData(action.response);
                break;
            }
            case "DRAFT_SIMILARTXN": {
                this._setDraftSimilarTxn(action.response);
                break;
            }
            case "DRAFT_BULK_UPLOAD": {
                this._setDraftBulkUpload(action.response, action.name);
                break;
            }
            case "MEARGE_EXPENSES": {
                this._setMeargeData(action.response, action.type);
            }
            // break omitted
            case "DRAFT_BULK_FAILED": {
                this._setDraftBulkFailed(action.response, action.name);
                break;
            }
            case "SHARE_ACCEPT": {
                this.emit("change", "acceptShare");
                break;
            }
            case "DISPUTE_REASON": {
                this._setDisputeReason(action.response);
                break;
            }
            case "ATTACHMENTS_S3": {
                this._setAttachmentS3Url(action.response);
                break;
            }
            case "ATTACHMENTS_S3_FAILD": {
                this.emit("change", action.type);
            }
            case "GET_TXN_ACTION": {
                this._setTxnAction(action.response, action.type);
                break;
            }
            case "PARENT_TXN_DATA_Of_SHARED_EXPENSE": {
                this.emit("change", "parentTxnDataOfSharedExpense", action.txn_data);
                break;
            }
            case "TRANSACTION_INFO_SMART_AUDIT_SUCCESS": {
                this.emit("change", action.type, action.response);
                break;
            }
            case "ATTACHMENT_PARSED": {
                this._setParsedData(action.response, action.index, false, true, action.fromImagePart);
                break;
            }
            case "ATTACHMENT_PARSED_FAILD": {
                this.setparseFailed(action.response, action.index);
                break;
            }
            case "bulkCreateTxn": {
                this._setBulkCreate(action.response);
                break;
            }
            case "BULK_DELETE_SUCCESS": {
                this._setDeletedTxnDtls(action.type, action.response);
                break;
            }
            case "EXPENSE_STEPPER_DIALOG": {
                this.setLoaderIcon(action.loader);
                break;
            }
        }
    }
}
const expenseStores = new ExpenseStores();
if (process.env.NODE_ENV !== "production") window.expStores = expenseStores;
dispatcher.register(expenseStores._handleActions.bind(expenseStores));
export default expenseStores;
